<template>
    <div class="announce-detail"
         v-loading="isLoading"
         element-loading-text="拼命加载中">
        <section class="video-wrap"
                 v-if='detail.videos&&detail.videos.length'>
            <div class="video">
                <video id="video-player"
                       class="video-js vjs-big-play-centered"
                       controls
                       :poster='detail.coverPic'>
                    <source :src="detail.videos&&detail.videos.length?detail.videos[0].content:''"
                            type="application/x-mpegURL"></source>
                </video>
            </div>
        </section>
        <section class="announce-desc">
            <header class='clearfix'>
                <button v-for="file in detail.files"
                        :key="file.src"
                        class="btn-sm btn btn-preview"
                        @click="previewAttachment(file)">查看课件</button>
                <h2 class="announce-title">{{detail.title}}</h2>
            </header>
            <section>
                <section class="online-time">{{detail.onlineTime| timeformat('yyyy-MM-dd')}}</section>
                <section class="image-text"
                         v-html="detail.contentText"
                         ref="richText"></section>
            </section>
        </section>
    </div>
</template>
<script>
    import timeformat from "filters/timeformat";
    import { getAnnounceDetail, readAnnounnce } from "api/academy";
    import { addSources } from 'utils/lazyLoad';
    const videojsUrls = ['//awp-assets.meituan.net/hfe/fep/b2817623d49522f2f015c2fb3aeb4347.js', '//awp-assets.meituan.net/hfe/fep/6fbdfe1b23c24b13f7eb64f887ea0c7c.css'];
    export default {
        data: function () {
            return {
                isLoading: true,
                detail: {
                    title: null,
                    contentText: null,
                    videos: [],
                    files: [],
                    coverPic: null
                }
            };
        },
        filters: {
            timeformat
        },
        created() {
            let id = this.$route.params.id;
            readAnnounnce(id);
            getAnnounceDetail(id)
                .then(response => {
                    let data = response && response.data;
                    this.detail = data;
                    if (this.detail.videos && this.detail.videos.length) {
                        setTimeout(() => {
                            this.loadVideo();
                        }, 0);
                    } else {
                        this.isLoading = false;
                    }
                    setTimeout(() => {
                        var ele = this.$refs.richText;
                        if (ele) {
                            let width = ele.offsetWidth;
                            if (ele.querySelectorAll) {
                                let imgs = ele.querySelectorAll("img");
                                if (imgs && imgs.length) {
                                    [...imgs].forEach(img => {
                                        if (img.width && img.width > width) {
                                            console.log("width");
                                            img.setAttribute("width", width.toString());
                                        } else {
                                            img.onload = ev => {
                                                let srcEle = ev.srcElement;
                                                if (srcEle.width > width) {
                                                    console.log("loadWidth");
                                                    srcEle.setAttribute("width", width.toString());
                                                }
                                            };
                                        }
                                    });
                                }
                            }
                        }
                    }, 0);
                })
                .catch(err => { });
        },
        methods: {
            previewAttachment(file) {
                window.open(file.content, "_blank");
            },
            loadVideo() {
                let options = { techOrder: ["Html5", "flash"] };
                this.isLoading = true;
                addSources(videojsUrls).then(() => {
                    videojs("video-player", options);
                    this.isLoading = false;
                }).catch(err => {
                    console.error(err);
                });
            }
        }
    };
</script>
<style lang="scss">
    .announce-detail {
      .image-text {
        font-size: 16px;
        line-height: 2em;
        ol {
          list-style-type: decimal;
          padding-left: 2em;
        }
        td {
          padding: 10px;
        }
      }
    }
</style>
<style lang="postcss" scoped>
    .announce-detail {
      width: 1020px;
      margin: 0 auto;
      padding: 20px 10px;
      .title {
        margin: 10px 0;
      }
      .online-time {
        color: #999;
        padding: 5px 0 0 0;
      }
      .video-wrap {
        width: 100%;
        display: flex;
        .video-js {
          width: 100%;
          height: 100%;
        }
        .video {
          height: 562px;
          flex: 72;
          overflow: hidden;
        }
      }
      .announce-desc {
        padding: 20px;
        overflow: hidden;
        h3 {
          margin: 10px 0 0 0;
        }
        p:first {
          margin-top: 5px;
        }
        .announce-title {
          font-size: 24px;
          line-height: 33px;
          font-weight: 500;
          color: #152c3c;
          margin: 0;
          height: 33px;
          padding: 0;
        }
        header {
          height: 33px;
        }
        .btn-preview {
          background-image: url(https://p0.meituan.net/codeman/5fadb3b57b81f02b4e07b05ee2cdb5ce771.png);
          background-size: 16px 12px;
          background-position: 9px 8px;
          background-repeat: no-repeat;
          padding-left: 30px;
          float: right;
          background-color: #008aff;
          border-color: #008aff;
          color: white;
          margin: 2px 0;
          &:focus {
            outline: none;
          }
        }
      }
    }
</style>




// WEBPACK FOOTER //
// AnnounceDetail.vue?35d71f36